/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The female formula includes hip circumference because body-fat distribution differs, which improves the estimate's accuracy.`)
};

const es_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fórmula femenina incluye la circunferencia de cadera porque la distribución de grasa corporal es diferente, lo que mejora la precisión de la estimación.`)
};

const de_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Formel für Frauen berücksichtigt den Hüftumfang, weil sich die Fettverteilung unterscheidet, was die Genauigkeit der Schätzung verbessert.`)
};

const nl_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vrouwenformule bevat de heupomtrek omdat de vetverdeling anders is, wat de nauwkeurigheid van de schatting verbetert.`)
};

const fr_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La formule féminine inclut le tour de hanches car la répartition de la masse grasse diffère, ce qui améliore la précision de l'estimation.`)
};

const it_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La formula femminile include la circonferenza dei fianchi perché la distribuzione del grasso corporeo è diversa, il che migliora la precisione della stima.`)
};

const pt_br2_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fórmula feminina inclui a circunferência do quadril porque a distribuição de gordura corporal é diferente, o que melhora a precisão da estimativa.`)
};

const pt_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fórmula feminina inclui a circunferência da anca porque a distribuição de gordura corporal é diferente, o que melhora a precisão da estimativa.`)
};

const ja_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体脂肪の分布が異なるため、女性用の計算式にはヒップ周りが含まれており、これにより推定精度が向上します。`)
};

const zh_bf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性公式包含臀围，因为男女体脂分布不同，加入该数据可提高估算准确度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_a3", locale)
	if (locale === "en") return en_bf_faq_a3(inputs)
	if (locale === "es") return es_bf_faq_a3(inputs)
	if (locale === "de") return de_bf_faq_a3(inputs)
	if (locale === "nl") return nl_bf_faq_a3(inputs)
	if (locale === "fr") return fr_bf_faq_a3(inputs)
	if (locale === "it") return it_bf_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_a3(inputs)
	if (locale === "pt") return pt_bf_faq_a3(inputs)
	if (locale === "ja") return ja_bf_faq_a3(inputs)
	return zh_bf_faq_a3(inputs)
};